import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7acc28c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scoreName" }
const _hoisted_2 = { class: "industryName" }
const _hoisted_3 = { class: "scoreName" }
const _hoisted_4 = { class: "industryName" }
const _hoisted_5 = { class: "scoreName" }
const _hoisted_6 = { class: "industryName" }
const _hoisted_7 = {
  key: 0,
  class: "mobile-pagination-bg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paginationItem" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.country)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "industryPerformanceScore"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (_ctx.comparisonMode)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12",
                    class: "pl-3 mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (entry) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              key: entry.name,
                              cols: "6",
                              class: "pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: _normalizeClass([entry.name.toLowerCase(), "pa-0"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_img, {
                                          src: require('@/assets/icons/industry/' + entry.name.toLocaleLowerCase() + '.svg'),
                                          class: _normalizeClass('industryIcon ' + entry.name.toLocaleLowerCase())
                                        }, null, 8, ["src", "class"])
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_1, [
                                      _createTextVNode(_toDisplayString(entry.name) + " ", 1),
                                      _withDirectives((_openBlock(), _createBlock(_component_v_icon, { class: "rating-tooltip" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-information-outline")
                                        ]),
                                        _: 2
                                      }, 1024)), [
                                        [_directive_tooltip, entry.tooltip]
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, { class: "infoRow" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.industries, (industry) => {
                                          return (_openBlock(), _createBlock(_component_v_row, {
                                            key: industry.name,
                                            class: "pa-0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "pa-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_img, {
                                                    src: require('@/assets/icons/tick.svg'),
                                                    class: "tickIcon"
                                                  }, null, 8, ["src"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "10",
                                                class: "pa-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_2, _toDisplayString(industry.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.isMobile)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.paginatedData, (entry) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: entry.name,
                            md: "2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "pa-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_img, {
                                        src: require('@/assets/icons/industry/' + entry.name.toLocaleLowerCase() + '.svg'),
                                        class: _normalizeClass('industryIcon ' + entry.name.toLocaleLowerCase())
                                      }, null, 8, ["src", "class"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_3, [
                                    _createTextVNode(_toDisplayString(entry.name) + " ", 1),
                                    (_ctx.isMobile)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          "open-on-click": "",
                                          width: "90%",
                                          class: "rating-tooltip"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_img, _mergeProps({ ref_for: true }, props, {
                                              src: require('@/assets/icons/atradius-info.svg'),
                                              class: "info-icon"
                                            }), null, 16, ["src"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(entry.tooltip), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.industries, (industry) => {
                                        return (_openBlock(), _createBlock(_component_v_row, {
                                          key: industry.name,
                                          class: "pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "1",
                                              class: "pa-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_img, {
                                                  src: require('@/assets/icons/tick.svg'),
                                                  class: "tickIcon"
                                                }, null, 8, ["src"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "10",
                                              class: "pa-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_4, _toDisplayString(industry.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.organizedData, (entry) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: entry.name
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "pa-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_img, {
                                        src: require('@/assets/icons/industry/' + entry.name.toLocaleLowerCase() + '.svg'),
                                        class: _normalizeClass('industryIcon ' + entry.name.toLocaleLowerCase())
                                      }, null, 8, ["src", "class"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_5, [
                                    _createTextVNode(_toDisplayString(entry.name) + " ", 1),
                                    _withDirectives((_openBlock(), _createBlock(_component_v_icon, { class: "rating-tooltip" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-information-outline")
                                      ]),
                                      _: 2
                                    }, 1024)), [
                                      [_directive_tooltip, entry.tooltip]
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, { class: "infoRow" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.industries, (industry) => {
                                        return (_openBlock(), _createBlock(_component_v_row, {
                                          key: industry.name,
                                          class: "pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "1",
                                              class: "pa-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_img, {
                                                  src: require('@/assets/icons/tick.svg'),
                                                  class: "tickIcon"
                                                }, null, 8, ["src"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "10",
                                              class: "pa-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_6, _toDisplayString(industry.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                  ], 64))
            ]),
            _: 1
          }),
          (_ctx.pageCount > 1 && (_ctx.comparisonMode && _ctx.isMobile && !_ctx.duplicate && !_ctx.singleCompare))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.pageCount > 1 && (_ctx.comparisonMode || _ctx.isMobile))
            ? (_openBlock(), _createBlock(_component_v_pagination, {
                value: _ctx.sharedPage,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.pageChanged($event))),
                length: _ctx.pageCount,
                key: _ctx.pageCount,
                class: _normalizeClass(_ctx.paginationClasses()),
                density: "compact",
                variant: "text"
              }, {
                item: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["value", "length", "class"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}